import { useState, useEffect } from 'react';
import RangeFilter from './RangeFilter';
import { ClickAwayListener } from '@mui/material';

interface BudgetDropdownProps {
    value: [number, number];
    onChange: (range: [number, number]) => void;
}

export default function BudgetDropdown({ value, onChange }: BudgetDropdownProps) {
    const [isOpen, setIsOpen] = useState(false);
    const [tempValue, setTempValue] = useState<[number, number]>(value);

    useEffect(() => {
        setTempValue(value);
    }, [value]);

    const handleApply = () => {
        onChange(tempValue);
        setIsOpen(false);
    };

    const handleClear = () => {
        setTempValue([0, 0]);
    };

    const isDefaultValue = value[0] === 0 && value[1] === 0;

    return (
        <ClickAwayListener onClickAway={() => setIsOpen(false)}>
            <div className="relative h-[42px]">
                <div
                    className="flex items-center h-full px-3 border border-my-gray rounded-lg cursor-pointer hover:border-my-blue"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <div className="flex items-center">
                        <span className="text-sm text-light-black/80">
                            {isDefaultValue ? 'Budget' : `€${value[0].toLocaleString()} - €${value[1].toLocaleString()}`}
                        </span>
                    </div>
                </div>
                {isOpen && (
                    <div className="absolute top-full left-0 w-full mt-0.5 bg-white rounded-lg shadow-lg p-2 z-10">
                        <RangeFilter
                            title=""
                            description=""
                            unit="€"
                            limit={[0, 50000000]}
                            steps={[
                                { max: 500000, step: 25000 },
                                { max: 1000000, step: 50000 },
                                { max: 5000000, step: 100000 },
                                { max: 10000000, step: 500000 },
                                { max: 50000000, step: 1000000 },
                            ]}
                            classNames="flex flex-col relative border-none"
                            onChanged={setTempValue}
                            value={tempValue}
                            isShownClearButton={false}
                        />
                        <div className="flex justify-end gap-2 mt-2">
                            <button className="px-4 py-2 text-my-blue hover:bg-gray-100 rounded-lg" onClick={handleClear}>
                                Clear
                            </button>
                            <button className="px-4 py-2 bg-my-blue text-white rounded-lg hover:bg-my-blue/90" onClick={handleApply}>
                                Apply
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </ClickAwayListener>
    );
}
